module.exports = __webpack_public_path__ + "static/media/Help.7adc0417.svg";